import React from 'react'
import useStyles from './styles'

const AvatarSkeleton = () => {
  const classes = useStyles()

  return <div className={classes.avatar} />
}

export default AvatarSkeleton
